// material
import { styled } from '@mui/material/styles';
import { Box, Container, Typography } from '@mui/material';
// layouts
// components
import Page from '../../components/styled-components/Page';
import { RegisterForm } from '../../components/users/register';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(0, 0)
}));

// ----------------------------------------------------------------------

export default function Register () {
  return (
    // @ts-ignore
    <RootStyle title="New User | Wakaafrica Dashboard">

      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Create a new Admin
            </Typography>

          </Box>

          <RegisterForm />

        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
